import { Component, OnInit, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { VgAPI, VgFullscreenAPI, VgControlsHidden } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'vg-share',
    encapsulation: ViewEncapsulation.None,
    template: `<div class="icon vg-icon-share" (click)="toggle()"></div>
               `,
    styles: [`        
        vg-share {
            z-index: 300;
            user-select: none;  
            display: flex;
            justify-content: center;
            height: 50px;
            width: 40px;
            margin-right:10px;
            cursor: pointer;
            color: white;
            line-height: 50px;
            -webkit-touch-callout: none;  
        }
        @media (max-width:767px){
            vg-share {
                display:none
            }
        }
    `]
})
export class VgShare {
    private elem: HTMLElement;
    private openShare: Boolean = false;

    constructor(ref: ElementRef, public API: VgAPI, public fsAPI: VgFullscreenAPI, private controlsHidden: VgControlsHidden, private eventInteraction: EventInteraction,) {
        this.elem = ref.nativeElement;
    }

    toggle() {
        if(!this.openShare)
        {
            this.eventInteraction.next({key: "openSocialShare", message:  {source: "vg-share"}});
            this.openShare = true;
        }
        else
        {
            this.eventInteraction.next({key: "closeSocialShare", message:  {source: "vg-share"}});
            this.openShare = false;
        }
       
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-share.component.ts